import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/core/styles'

import registerServiceWorker from './registerServiceWorker'
import theme from './theme'
// import store from './redux/store'
import './styles/index.css'
import App from './App'
import configureStore from './store/store'
const target = document.querySelector('#root')

render(
  <ThemeProvider theme={theme}>
    <Provider store={configureStore()}>
      <BrowserRouter>
        <CssBaseline/>
        <App/>
      </BrowserRouter>
    </Provider>
  </ThemeProvider>,
  target
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js